import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-center align-center" },
        [
          _c("div", { staticClass: "text-subtitle-2 ma-2 text-center" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$vuetify.lang.t("$vuetify.dashboard.activityTitle")
                ) +
                " "
            ),
          ]),
          _c(
            VBtn,
            { attrs: { icon: "" }, on: { click: _vm.toggleDateMode } },
            [
              _vm.isRange
                ? _c(VIcon, [_vm._v("mdi-calendar")])
                : _c(VIcon, [_vm._v("mdi-calendar-range")]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "d-flex justify-center mt-4" }, [
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            !_vm.isRange
              ? _c(
                  VBtn,
                  {
                    attrs: { icon: "" },
                    on: {
                      click: function ($event) {
                        return _vm.addDay(-1)
                      },
                    },
                  },
                  [_c(VIcon, [_vm._v(" mdi-chevron-left ")])],
                  1
                )
              : _vm._e(),
            _c("date-picker", {
              key: "start-date-picker" + _vm.snapshotStartDate,
              staticClass: "mx-2",
              staticStyle: { "max-width": "300px" },
              attrs: {
                outlined: "",
                dense: "",
                label: _vm.$vuetify.lang.t("$vuetify.base.startDate"),
                defaultNowOnNull: false,
                "show-hint": false,
                "show-icon": false,
              },
              model: {
                value: _vm.snapshotStartDate,
                callback: function ($$v) {
                  _vm.snapshotStartDate = $$v
                },
                expression: "snapshotStartDate",
              },
            }),
            _vm.isRange
              ? _c("date-picker", {
                  key: "end-date-picker" + _vm.snapshotEndDate,
                  staticClass: "mx-2",
                  staticStyle: { "max-width": "300px" },
                  attrs: {
                    outlined: "",
                    dense: "",
                    label: _vm.$vuetify.lang.t("$vuetify.base.endDate"),
                    defaultNowOnNull: false,
                    "show-hint": false,
                    "show-icon": false,
                  },
                  model: {
                    value: _vm.snapshotEndDate,
                    callback: function ($$v) {
                      _vm.snapshotEndDate = $$v
                    },
                    expression: "snapshotEndDate",
                  },
                })
              : _vm._e(),
            !_vm.isRange
              ? _c(
                  VBtn,
                  {
                    attrs: { icon: "" },
                    on: {
                      click: function ($event) {
                        return _vm.addDay(1)
                      },
                    },
                  },
                  [_c(VIcon, [_vm._v(" mdi-chevron-right ")])],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("production-snapshot", {
        attrs: {
          startDate: _vm.snapshotStartDate,
          endDate: _vm.snapshotEndDate,
        },
      }),
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-space-around flex-column flex-lg-row mt-8",
        },
        [
          _c("receiving-snapshot", {
            attrs: {
              startDate: _vm.snapshotStartDate,
              endDate: _vm.snapshotEndDate,
            },
          }),
          _c("packaging-snapshot", {
            attrs: {
              startDate: _vm.snapshotStartDate,
              endDate: _vm.snapshotEndDate,
            },
          }),
        ],
        1
      ),
      _c(VDivider, { staticClass: "my-4" }),
      _c(
        "div",
        { staticClass: "mb-8" },
        [
          _c("inventory-balances", {
            on: {
              inventoryLoaded: function ($event) {
                _vm.inventoryReady = true
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }